// src/components/Notification.jsx
import { motion, AnimatePresence } from "framer-motion";
import { CheckCircle2, XCircle, Info, AlertTriangle } from "lucide-react";

const icons = {
  success: CheckCircle2,
  failed: XCircle,
  info: Info,
  warning: AlertTriangle,
};

const colors = {
  success: "bg-green-100 text-green-800 border-green-300",
  failed: "bg-red-100 text-red-800 border-red-300",
  info: "bg-blue-100 text-blue-800 border-blue-300",
  warning: "bg-yellow-100 text-yellow-800 border-yellow-300",
};

export default function NotificationStack({ notifications, onClose }) {
  return (
    <div className="fixed top-4 left-1/2 -translate-x-1/2 sm:top-16 sm:right-9 sm:left-auto sm:translate-x-0 flex flex-col gap-3 z-[9999] w-[calc(100%-2rem)] sm:w-80">
      <AnimatePresence>
        {notifications.map((note) => {
          const Icon = icons[note.type] || Info;
          const colorClass = colors[note.type] || colors.info;

          return (
            <motion.div
              key={note.id}
              initial={{ opacity: 0, y: -20 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: 20 }}
              transition={{ duration: 0.25 }}
              className={`flex items-start gap-3 p-4 rounded-lg border shadow-md w-80 ${colorClass}`}
            >
              <Icon className="w-6 h-6 mt-1 shrink-0" />
              <div className="flex-1">
                {note.title && (
                  <h3 className="font-semibold text-sm mb-0.5">{note.title}</h3>
                )}
                <p className="text-sm">{note.message}</p>
              </div>
              <button
                onClick={() => onClose(note.id)}
                className="ml-2 text-gray-500 hover:text-gray-700 transition"
              >
                ✕
              </button>
            </motion.div>
          );
        })}
      </AnimatePresence>
    </div>
  );
}
